<template>
  <div class="layout-wrapper d-flex flex-column">
    <div class="topbar d-flex">
      <div class="brand bg-white shadow d-flex align-items-center justify-content-center">
        <!-- <Link href="/"><h4 class="text-light">Disperindag</h4></Link> -->
        <Link href="/" class="px-4 d-flex justify-content-center">
          <img src="/img/satu_data_hitam.png" alt="Logo" style="width: 85%;">
        </Link>
      </div>
      <nav class="flex-fill py-3 navbar navbar-expand navbar-light bg-white shadow">
        <div class="container-fluid">
          <Link class="navbar-brand" href="#">
            <Icon :icon="['fa', 'bars']" />
          </Link>
          <ul class="navbar-nav">
            <li class="nav-item">
              <Link class="nav-link" aria-current="page" href="/admin">Pindah Aplikasi</Link>
            </li>
            <!-- <li class="nav-item">
              <Link class="nav-link" href="#">Notifikasi</Link>
            </li> -->
            <li class="nav-item dropdown">
              <Link class="nav-link dropdown-toggle" @click.prevent="show_account = !show_account">Akun <Icon :icon="['fa', 'chevron-down']" /></Link>
              <ul class="dropdown-menu" :class="{ 'show': show_account }" style="right: 0;">
                <li><Link class="dropdown-item" href="/admin/profile">Profil</Link></li>
                <li><Link class="dropdown-item" href="/admin/profile/akun">Pengaturan Akun</Link></li>
                <li><hr class="dropdown-divider" /></li>
                <li><Link class="dropdown-item" @click.prevent="logout">Logout</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="main-content d-flex flex-fill">
      <div class="sidebar p-3">
        <nav class="nav flex-column">
          <li class="nav-link active">
            <Link href="/admin/dashboard">
              <Icon :icon="['fa', 'home']" />
              <span>Dashboard</span>
            </Link>
          </li>
          <li v-if="appmode == 'portal'" class="menu-title">PORTAL</li>
          <li v-if="appmode == 'portal'" class="nav-link">
            <Link href="/admin/portal/posts">
              <Icon :icon="['fa', 'newspaper']" />
              <span class="badge rounded-pill bg-primary float-end">4</span>
              <span>Postingan</span>
            </Link>
          </li>
          <li v-if="appmode == 'portal'" class="nav-link">
            <Link href="/admin/portal/pages">
              <Icon :icon="['fa', 'pager']" />
              <span>Pages</span>
            </Link>
          </li>
          <li v-if="appmode == 'portal'" class="nav-link">
            <Link href="/admin/portal/slider">
              <Icon :icon="['fa', 'columns']" />
              <span>Slider</span>
            </Link>
          </li>
          <li v-if="appmode == 'portal'" class="nav-link">
            <Link href="/admin/portal/runningtext">
              <Icon :icon="['fa', 'forward']" />
              <span>Running Text</span>
            </Link>
          </li>
          <li v-if="appmode == 'portal'" class="nav-link">
            <Link href="/admin/portal/setting">
              <Icon :icon="['fa', 'calendar']" />
              <span>Setting Halaman</span>
            </Link>
          </li>
          <li v-if="appmode == 'portal'" class="nav-link">
            <Link href="/admin/portal/menu">
              <Icon :icon="['fa', 'gears']" />
              <span>Setting Menu</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="menu-title">MANAJEMEN SATUDATA</li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagindustri">
              <Icon :icon="['fa', 'industry']" />
              <span>Data Industri</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagexport">
              <Icon :icon="['fa', 'truck-pickup']" />
              <span>Data Export</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagproyek">
              <Icon :icon="['fa', 'building']" />
              <span>Daftar Proyek</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagiup">
              <Icon :icon="['fa', 'file-contract']" />
              <span>Data IUP</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagikm">
              <Icon :icon="['fa', 'city']" />
              <span>Data IKM</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagtenagakerjaikm">
              <Icon :icon="['fa', 'code-fork']" />
              <span>Tenaga Kerja IKM</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagproduksiikm">
              <Icon :icon="['fa', 'box-archive']" />
              <span>Produksi IKM</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagijinhalal">
              <Icon :icon="['fa', 'certificate']" />
              <span>Data Ijin Halal</span>
            </Link>
          </li>
          <!-- <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/elementsdata">
              <Icon :icon="['fa', 'th']" />
              <span>Element Data</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/inputdata">
              <Icon :icon="['fa', 'pen-square']" />
              <span>Input Data</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'file-signature']" />
              <span>Permohonan</span>
            </Link>
          </li> -->
          <li v-if="appmode == 'satudata'" class="menu-title">MASTER DATA</li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/domisilidata">
              <Icon :icon="['fa', 'map-location-dot']" />
              <span>Lokasi</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/instansidata">
              <Icon :icon="['fa', 'building']" />
              <span>Instansi</span>
            </Link>
          </li>
          <!-- <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/skpddata">
              <Icon :icon="['fa', 'sitemap']" />
              <span>SKPD</span>
            </Link>
          </li> -->
          <!-- <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/penggunaandata">
              <Icon :icon="['fa', 'bridge']" />
              <span>Penggunaan</span>
            </Link>
          </li> -->
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagsentra">
              <Icon :icon="['fa', 'section']" />
              <span>Daftar Sentra</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagklasifikasi">
              <Icon :icon="['fa', 'history']" />
              <span>Data Klasifikasi</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/indagpegawai">
              <Icon :icon="['fa', 'user-tie']" />
              <span>Data Pegawai</span>
            </Link>
          </li>
          <li class="menu-title">ADMINISTRASI</li>
          <li class="nav-link">
            <Link href="/admin/users">
              <Icon :icon="['fa', 'users']" />
              <span>Akun Pengguna</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="/admin/roles">
              <Icon :icon="['fa', 'diagram-project']" />
              <span>Hak Akses</span>
            </Link>
          </li>
          <li v-if="appmode == 'satudata'" class="nav-link">
            <Link href="/admin/settingdata">
              <Icon :icon="['fa', 'gears']" />
              <span>Pengaturan</span>
            </Link>
          </li>
          <!-- <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'gears']" />
              <span>Pengaturan Aplikasi</span>
            </Link>
          </li> -->
        </nav>
      </div>
      <div class="content p-2 flex-fill">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';

const renderActiveMenu = (pathname) => {
  document.querySelectorAll('.sidebar .nav-link.active').forEach(el => {
    el.setAttribute('class', el.getAttribute('class').replace('active', '').trim());
  });
  // // cek dengan mencari link dengan posisi url saat ini
  // document.querySelectorAll('.nav-link > a[href="'+url.pathname+'"]').forEach(({ parentElement }) => {
  //   parentElement.setAttribute('class', parentElement.getAttribute('class').trim() + ' active');
  // });
  // cek semua link lalu bandingkan
  document.querySelectorAll('.nav-link > a:not([href=""])').forEach(el => {
    if(pathname.startsWith(el.getAttribute('href'))) {
      el.parentElement.setAttribute('class', el.parentElement.getAttribute('class').trim() + ' active');
    }
  });
}

export default {
  props: {
    auth: Object,
    appmode: String
  },
  data() {
    return {
      signout: this.$inertia.form(),
      show_account: false
    }
  },
  methods: {
    logout() {
      this.signout.delete('/auth/logout');
    }
  },
  mounted() {
    renderActiveMenu(location.pathname);
  },
  created() {
    Inertia.on('start', (event) => {
      const { url } = event.detail.visit;
      renderActiveMenu(url.pathname);
    });
  }
}
</script>

<style lang="scss">
@import '../../css/bootstrap';
@import '../../css/style';
</style>
